import {
    EVENT_SET_DATA,
    EVENT_SET_ERROR,
    EVENT_SET_OWNERSHIP_DATA,
    EVENT_SET_OWNERSHIP_ERROR
} from './event-manager.constants';
import { IEventResponse, IEventOwnershipResponse } from './event-manager.service';
import EventManagerError from './event-manager-error';
import { Actions } from './event-manager.actions';

export interface IState {
    data?: IEventResponse;
    error: EventManagerError | null;
    ownershipData: IEventOwnershipResponse | { [key: string]: null };
}

export const initialState: IState = {
    error: { type: null },
    ownershipData: { gameId: null, code: null, name: null, platforms: null }
};

export const reducerKey = 'event';

export const event = (state: IState = initialState, action: Actions) => {
    switch (action.type) {
    case EVENT_SET_DATA:
        return {
            ...state,
            error: { type: null },
            data: action.payload
        };
    case EVENT_SET_ERROR:
        return {
            ...state,
            data: undefined,
            error: action.payload
        };
    case EVENT_SET_OWNERSHIP_DATA:
        return {
            ...state,
            error: { type: null },
            ownershipData: action.payload
        };
    case EVENT_SET_OWNERSHIP_ERROR:
        return {
            ...state,
            ownershipData: {
                gameId: null, // TODO review this field after update of API
                code: null,
                name: null,
                platforms: null
            },
            error: action.payload
        };
    default:
        return state;
    }
};

export default event;
